<template>
  <v-dialog
    :value="value"
    width="400px"
    @input="onClose"
    content-class="dialog-center-margin white"
  >
    <div class="px-6 pt-6 d-flex justify-space-between align-center">
      <p class="font-weight-medium" style="font-size: 18px">{{ $t('Active for notifications') }}</p>
      <VIcon style="color: white;cursor:pointer;" medium @click="onClose">mdi-close</VIcon>
    </div>
    <div class="tasks-container px-6">
      <div v-for="task in tasks" :key="task.id">
        <v-checkbox
          :key="task.uuid"
          :label="task.name"
          :value="task.uuid"
          :input-value="isTaskActive(task.uuid)"
          :value-comparator="isTaskActive"
          @change="toggleTask"
          hide-details />
      </div>
    </div>
    <div class="d-flex justify-end">
      <v-btn
        color="primary"
        elevation="0"
        @click="saveAlerts"
        class="ma-3"
      >{{$t('Confirm')}}</v-btn>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    memberId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      activeTasks: [],
    };
  },
  computed: {
    tasks() {
      return this.$Task.query().with('events')
        .where((task) => task.user === this.$route.params.userId).get();
    },
  },
  watch: {
    tasks: {
      handler(newVal) {
        this.activeTasks = newVal.filter((task) => task.alertEnabled).map((task) => task.uuid);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$Task.api().fetchByUserAndGroup(this.$route.params.userId, this.$route.params.groupName);
  },
  methods: {
    toggleTask(id) {
      if (this.activeTasks.includes(id)) {
        this.activeTasks = this.activeTasks.filter((taskId) => taskId !== id);
      } else {
        this.activeTasks.push(id);
      }
    },
    onClose() {
      this.$emit('input', false);
    },
    isTaskActive(id) {
      return this.activeTasks.includes(id);
    },
    saveAlerts() {
      this.$Alert.api().updateUserAlerts(this.$route.params.groupName, this.$route.params.userId, this.activeTasks).then(() => {
        this.onClose();
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
